import { AIAgent } from "@graylog/enterprise-api";
import FiltersForQueryParams from "components/common/EntityFilters/FiltersForQueryParams";
const enrichAttributes = (attributes) => attributes.map((attr) => attr.id === "type" ? { ...attr, sliceable: true } : attr);
const fetchAgentWorkflowRuns = (searchParams) => AIAgent.runsPaginated(
  searchParams.page,
  searchParams.pageSize,
  searchParams.sort.attributeId,
  searchParams.sort.direction,
  searchParams.query,
  FiltersForQueryParams(searchParams.filters)
).then(({ elements, pagination: { total }, attributes }) => ({
  list: elements,
  pagination: { total },
  attributes: enrichAttributes(attributes)
}));
export default fetchAgentWorkflowRuns;
